$( document ).ready(function() { 
$('#Details-collapsible-row-2-template--17777976705308__main').trigger("click");

  
$('.addnewbtn').click(function() {
   $('#AddAddress').toggleClass("show");
  
})
$('#addnewcancel').click(function() {
  $('#AddAddress').removeClass("show");
  

})
  $(".editbtn").click(function() {
    var addid = $(this).attr('data-address-id');
    $("#EditAddress_"+addid).toggleClass("showedit");
})
  $(".cn-update").click(function() {
    $(this).parent().parent().parent().removeClass("showedit");
  })
$('.outfitview').click(function() {
  $(this).css("display","none");
  $('.clothview').css("display","block");
     $('#product-grid li').each(function() {
     $(this).find(".image-2").addClass('custom-hover-img'); 
     $(this).find(".image-1").removeClass('custom-hover-img');
    });
});
 $('.clothview').click(function() {
  
  $(this).css("display","none");
  $('.outfitview').css("display","block");
     $('#product-grid li').each(function() {
       $(this).find(".image-2").removeClass('custom-hover-img');
       $(this).find(".image-1").addClass('custom-hover-img');
    }); 
  }); 
   $(".card-wrapper").mouseover(function(){
    
      $(this).find(".image-1").removeClass('custom-hover-img'); 
     $(this).find(".image-2").removeClass('custom-hover-img');
   });
  
  /*
$(".mega-menu").hover(function(){
  console.log("hover");
  $('body').addClass("menuopen");
});
 $(".mega-menu").mouseout(function(){
   console.log("out hover");
  $('body').removeClass("menuopen");
 });
  */
  
if (window.matchMedia("(max-width: 767px)").matches) {

   $('.panel').css('display','none');
        $('.accordion').click(function(){
        var $this = $(this);
          if ($this.parent().find('.panel').is(":visible")) {
            $this.parent().find('.panel').slideUp(350);
            $this.removeClass("open");
          } else {
            $this.parent().find('.panel').slideDown(350);
            $this.addClass("open");
          }
       }); 





  
}
$('.mega-menu').mouseover(function(){ 
   
    var getid = $(this).attr('id');  
    if(getid == 'Details-HeaderMenu-1'){
      $(this).attr("open", true);    
    

            
    }  
   $('body').addClass('menuopen');
  });
  $('.mega-menu').mouseleave(function(){ 
    $('body').removeClass('menuopen');
  });
$('.mega-menu__content').mouseleave(function(){            
    $('.mega-menu').attr("open",false);    
 
  
})

  



  
$('#custSlider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: false,
  arrow: true,
  responsive: [{
	    breakpoint: 1024,
	    settings: {
	      slidesToShow: 4,
	      infinite: true,
          
	    }
	  }, {
	    breakpoint: 600,
	    settings: {
	      slidesToShow: 3,
	      dots: true,
          
	    }


	  }, {
 

	    breakpoint: 480,

	    settings: {
	      slidesToShow: 2,
	      dots: true,
          
	    }

	 

	  }]
  
});
     });




var theInterval;
function stopSlide() {
    clearInterval(theInterval);
}
     
   $('#shopify-section-slideshow').mouseover(function(){ 
     stopSlide();
   });

$(document).ready(function() {
  var interval = setInterval(function() {
    if ($('.globo-swatch-list').length) {
      // The element with class .globo-swatch-list exists
      clearInterval(interval); // Stop the interval
      // Your code here to work with the element
     $( ".globo-swatch-list .swatch--gl" ).each(function( index ) {
var attrname = $(this).find('legend').attr('data-name');
 if(attrname == 'Colour' || attrname == 'Color'){
   var metavalue = $('#product-meta-color').val();
   if (metavalue != ''){
   var textmetavalue = '<span class="attr-title-hover">'+metavalue+'</span>'+metavalue;
     $(this).find('ul li label').html(textmetavalue);
   }
     return false; // exit the loop
 }
});  
    }
  }, 100);
});


$( document ).ready(function() {

// vanilla JS
window.addEventListener("load", (event) => {});
window.onload = (event) => {};

// JQuery
$(window).on('load', function() {
  
  var count = $(".globo-swatch-list").children().length;
 // console.log(count);
  if(count == '1'){
    $('.swatch--gl.clearfix').addClass("custom-size");
  }



  
$( ".globo-swatch-list" ).each(function( index ) {
  $(".swatch--gl.clearfix").find(".name-option").addClass("testing");
  console.log($(".swatch--gl.clearfix").find("legend.name-option").attr('data-name'));
  if('data-name' == 'Size'){
   
  }
  
});
  
})

});

$( document ).ready(function() {
/*--==== COUNT DIV to get last id ====--*/
var getLastID = 0;
$( ".mobile-facets__main details" ).each(function( index ) {  
   getLastID = parseInt(index)+1;
});
    /*-- GET COUNT VALUE FROM FILTERS Start --*/
  
    /*- FIRST LI -*/
    var getValue = $('#FacetMobile-'+getLastID+'-template--20266035216668__product-grid ul.mobile-facets__list.list-unstyled li.mobile-facets__item.list-menu__item:nth-child(1) span').text();
    var abc = getValue.split("(");
  if(abc >1){
    var def = abc[1].split(")");
    console.log(def[0]);
    $('.cust-brand li:nth-child(1) span.count').text("("+def[0]+")")
  }


    var getValue2 = $('#FacetMobile-'+getLastID+'-template--20266035216668__product-grid ul.mobile-facets__list.list-unstyled li.mobile-facets__item.list-menu__item:nth-child(2) span').text();
    var abc2 = getValue2.split("(");
    if(abc2 > 1){
      var def2 = abc2[1].split(")");
      console.log(def2[0]);
      $('.cust-brand li:nth-child(2) span.count').text("("+def2[0]+")")      
    }

    var getValue3 = $('#FacetMobile-'+getLastID+'-template--20266035216668__product-grid ul.mobile-facets__list.list-unstyled li.mobile-facets__item.list-menu__item:nth-child(3) span').text();
    var abc3 = getValue3.split("(");
    if(abc3 > 1){
      var def3 = abc3[1].split(")");
      console.log(def3[0]);
      $('.cust-brand li:nth-child(3) span.count').text("("+def3[0]+")")          
    }

  
  /*-- GET COUNT VALUE FROM FILTERS End --*/
/*--==== COUNT DIV to get last id ====--*/
  
   $("#all_fil").addClass('active');

 $("#883_fil").click(function() {
   $(this).addClass("active");
   $("#all_fil").removeClass('active');
   $("#pol_fil").removeClass('active');
   $("#plc_fil").removeClass('active');
    $('html,body').animate({
        scrollTop: $("#MainContent").offset().top},
        'slow');
      $(".facet-remove.active-facets__button span.active-facets__button-inner").trigger("click");    
  
    var listItems = $("#FacetMobile-"+getLastID+"-template--20266035216668__product-grid li");
      console.log(listItems.length);     
     listItems.each(function(idx, li) {
      var product = $(li);
      var chkval = $(this).find(".mobile-facets__checkbox").val();
       console.log(chkval);
        if(chkval == '883 Police'){
              $(this).find(".mobile-facets__checkbox").trigger( "click" );
     }
  });
});

 $("#pol_fil").click(function() {
   $(this).addClass("active");
   $("#all_fil").removeClass('active');
   $("#883_fil").removeClass('active');
   $("#plc_fil").removeClass('active');
    $('html,body').animate({
        scrollTop: $("#MainContent").offset().top},
        'slow');
      $(".facet-remove.active-facets__button span.active-facets__button-inner").trigger("click");    
  
    var listItems = $("#FacetMobile-"+getLastID+"-template--20266035216668__product-grid li");
      console.log(listItems.length);     
     listItems.each(function(idx, li) {
      var product = $(li);
      var chkval = $(this).find(".mobile-facets__checkbox").val();
       console.log(chkval);
        if(chkval == 'Police'){
              $(this).find(".mobile-facets__checkbox").trigger( "click" );
     }
  });
});
  

  $("#plc_fil").click(function() {
    $(this).addClass("active");
    $("#all_fil").removeClass('active');
   $("#pol_fil").removeClass('active');
   $("#883_fil").removeClass('active');
     $('html,body').animate({
        scrollTop: $("#MainContent").offset().top},
        'slow');
    $(".facet-remove .active-facets__button span.active-facets__button-inner").trigger("click");    
    var listItems = $("#FacetMobile-"+getLastID+"-template--20266035216668__product-grid li");
      listItems.each(function(idx, li) {
      var product = $(li);
      var chkval = $(this).find(".mobile-facets__checkbox").val();
        if(chkval == 'PLCE'){
              $(this).find(".mobile-facets__checkbox").trigger( "click" );
      }
 });
});

    $("#all_fil").click(function() {
      $(this).addClass("active");
      $("#883_fil").removeClass('active');
   $("#pol_fil").removeClass('active');
   $("#plc_fil").removeClass('active');
      
 $('html,body').animate({
        scrollTop: $("#MainContent").offset().top},
        'slow'); 
      //console.log("clicked");
      $(".facet-remove .active-facets__button span.active-facets__button-inner").trigger("click");    
    });
});


$( document ).ready(function() {
$('.active-facets-desktop').each(
  function() {
    //alert(($(this).find('facet-remove')).length);
    var cou = ($(this).find('facet-remove').length) - 1;
    console.log(cou);
  }
);
     $(document).on('click', '.accordion--orphan.faq .faq__question', function(){
                        $('.accordion--orphan.faq').removeClass('accordion--open');
                        $(this).parent().toggleClass('accordion--open');      
                    });
});

$( document ).ready(function() {

});